angular.module('bmsApp.trugreen.quote').controller('TGQuoteMainCtrl',
	function ($state,
			  $scope) {

		$scope.$on('quoteIndexUpdated', function (e, quoteData) {
			$scope.quoteData = quoteData;
		});

	});